import React from 'react';
export function Hero() {
  return <section id="hero" className="relative pt-16 pb-20 overflow-hidden" data-id="element-117">
      {/* Background image container with optimized animation */}
      <div className="absolute inset-0 w-full h-full" data-id="element-118">
        <picture data-id="element-119">
          <source srcSet="https://uploadthingy.s3.us-west-1.amazonaws.com/aFC8BsJhF5r9qvndnF3JxE/Gemini_Generated_Image_hu0dtkhu0dtkhu0d_%281%29.webp" type="image/webp" data-id="element-120" />
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/aFC8BsJhF5r9qvndnF3JxE/Gemini_Generated_Image_hu0dtkhu0dtkhu0d_%281%29.webp" alt="Woman wearing iRelief Oculis-3 eye massager device" className="w-full h-full object-cover object-center animate-fade-blur" width="1920" height="1080" fetchpriority="high" decoding="async" loading="eager" style={{
          contentVisibility: 'auto',
          contain: 'layout paint',
          willChange: 'opacity, filter'
        }} data-id="element-121" />
        </picture>
        {/* Enhanced gradient overlay with optimized animation */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0F172A]/90 via-[#0F172A]/70 to-[#0F172A]/40 animate-gradient" style={{
        willChange: 'background-position',
        contain: 'paint'
      }} data-id="element-122"></div>
        {/* Optimized floating elements */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-123">
          <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-[#0EA5B7] rounded-full opacity-5 animate-soft-bounce" style={{
          willChange: 'transform',
          contain: 'layout paint size',
          contentVisibility: 'auto'
        }} data-id="element-124"></div>
          <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-[#0EA5B7] rounded-full opacity-5 animate-breathe delay-1000" style={{
          willChange: 'transform',
          contain: 'layout paint size',
          contentVisibility: 'auto'
        }} data-id="element-125"></div>
          <div className="absolute top-3/4 left-1/3 w-40 h-40 bg-white rounded-full opacity-10 animate-gentle-sway delay-500" style={{
          willChange: 'transform',
          contain: 'layout paint size',
          contentVisibility: 'auto'
        }} data-id="element-126"></div>
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-8 relative z-10" data-id="element-127">
        <div className="max-w-2xl" data-id="element-128">
          {/* Badge with optimized animation */}
          <div className="inline-block bg-[#0EA5B7] text-white text-xs font-bold px-3 py-1 rounded mb-4 animate-fade-scale animate-glow-pulse" style={{
          willChange: 'transform, opacity, box-shadow',
          contain: 'layout paint'
        }} data-id="element-129">
            NEW RELIEF
          </div>
          {/* Headline with optimized 3D reveal effect */}
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-6 animate-reveal-3d" style={{
          willChange: 'transform, opacity',
          contain: 'layout paint'
        }} data-id="element-130">
            5 Reasons Why This Neurologist-Backed 15-Minute Ritual Broke My
            12-Year Migraine Depression (After $47,000 in Failed Treatments)
          </h1>
          {/* Subheading with optimized blur reveal */}
          <h2 className="text-xl text-gray-200 mb-6 font-medium reveal-blur" style={{
          willChange: 'opacity, filter',
          contain: 'layout paint'
        }} data-id="element-131">
            The multi-modal nerve reset technology that 12,000+ chronic
            sufferers call "Nobel Prize worthy" — targeting the hidden
            trigeminovascular chain reaction your doctor never explained
          </h2>
          {/* CTA button with optimized animations */}
          <div className="mb-4 reveal-scale" data-id="element-132">
            <a href="https://irelief.us/products/vibration-bluetooth-eye-massager-visual-eye-massage-intelligent-eye-mask-massage-masajeador-heating-eyemask-face-facial-massager" className="inline-block bg-[#0EA5B7] hover:bg-[#0F172A] text-white font-medium py-3 px-8 rounded-md transition-all duration-300 shadow-lg transform hover-shadow-grow btn-premium" style={{
            willChange: 'transform, box-shadow',
            contain: 'layout paint'
          }} data-id="element-133">
              Try iRelief Oculis-3 Risk-Free
            </a>
          </div>
          {/* Rating with optimized staggered animation */}
          <div className="flex items-center mb-4 animate-slide-up delay-300" style={{
          willChange: 'transform, opacity',
          contain: 'layout paint'
        }} data-id="element-134">
            <div className="flex" data-id="element-135">
              {[1, 2, 3, 4, 5].map((star, index) => <svg key={star} className={`w-4 h-4 text-yellow-500 fill-current animate-fade-in stagger-${index}`} viewBox="0 0 20 20" style={{
              willChange: 'opacity'
            }} data-id="element-136">
                  <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" data-id="element-137" />
                </svg>)}
            </div>
            <span className="text-xs text-gray-300 ml-2 animate-fade-in delay-500" data-id="element-138">
              300,000+ Happy Users
            </span>
          </div>
          {/* Guarantee text with optimized animation */}
          <div className="mb-4 reveal-up" data-id="element-139">
            <p className="text-white text-sm animate-border-flow inline-block py-1" style={{
            willChange: 'opacity'
          }} data-id="element-140">
              <span className="font-bold" data-id="element-141">100% Non-Invasive</span>, 90-Day Money
              Back Guarantee
            </p>
          </div>
          {/* Learn more link with optimized hover effect */}
          <div className="flex items-center reveal-up" data-id="element-142">
            <a href="https://irelief.us/products/vibration-bluetooth-eye-massager-visual-eye-massage-intelligent-eye-mask-massage-masajeador-heating-eyemask-face-facial-massager" className="text-[#0EA5B7] hover:text-white font-medium text-sm uppercase tracking-wider transition-colors group flex items-center hover-text-glow" onClick={e => {
            e.preventDefault();
            const introElement = document.getElementById('intro');
            if (introElement) {
              introElement.scrollIntoView({
                behavior: 'smooth'
              });
            }
            window.location.href = 'https://irelief.us/products/vibration-bluetooth-eye-massager-visual-eye-massage-intelligent-eye-mask-massage-masajeador-heating-eyemask-face-facial-massager';
          }} data-id="element-143">
              Learn More
              <svg className="w-4 h-4 ml-1 text-[#0EA5B7] group-hover:translate-x-1 transition-transform duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" style={{
              willChange: 'transform'
            }} data-id="element-144">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-145" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>;
}